'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shouldEstablishSession;

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shouldEstablishSession() {
    var excludedPaths = ['/racecards/', '/racecards/time-order/', '/racecards/time-order', '/racecards/tomorrow', '/racecards/tomorrow/', '/racecards/big-race-entries/', '/racecards/big-race-entries', '/racecards/us-racing/', '/racecards/us-racing', '/horse-tracker/tracked', '/horse-tracker/tracked/', '/horse-tracker/settings', '/horse-tracker/settings/', '/bloodstock/stallion-book/', '/bloodstock/sales/catalogues/', '/non-runners/'];

    var currentPath = window.location.pathname;

    var isProfilePage = currentPath.includes('/profile/horse') || currentPath.includes('/profile/owner') || currentPath.includes('/profile/trainer') || currentPath.includes('/profile/jockey');

    if (isProfilePage && typeof window.PRELOADED_STATE !== 'undefined') {
        var hasEntries = Boolean(window.PRELOADED_STATE.entries) || Boolean(window.PRELOADED_STATE.bookedRides);

        return hasEntries;
    }

    if (excludedPaths.includes(currentPath)) {
        return false;
    }

    var racecardDatePattern = /^\/racecards\/\d{4}-\d{2}-\d{2}\/?$/;
    if (racecardDatePattern.test(currentPath)) {
        return false;
    }

    var resultsPattern = /^\/results\/(\d{4}-\d{2}-\d{2})\/time-order\/?$/;
    var match = currentPath.match(resultsPattern);

    if (match) {
        var dateInUrl = (0, _dayjs2.default)(match[1]);
        var today = (0, _dayjs2.default)().startOf('day');
        var yesterday = today.subtract(1, 'day');

        if (dateInUrl.isBefore(today) && !dateInUrl.isBefore(yesterday)) {
            return false;
        }
    }

    return true;
} /* eslint-disable no-console */
// eslint-disable-next-line import/no-extraneous-dependencies


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/shouldEstablishSession.js
// module id = 1759
// module chunks = 1